import type { RouteConfig } from "@/router/types";
import { lazyWithRetry } from "@/shared/utils/lazyWithRetry";

const RouteNotFoundPage = lazyWithRetry(() => import("@/features/notFound/pages/RouteNotFoundPage").then((module) => ({ default: module.RouteNotFoundPage })));

const notFoundRoutes: RouteConfig[] = [
  {
    path: "*",
    element: <RouteNotFoundPage />,
    isProtected: true,
    useMainLayout: false,
  },
];

export default notFoundRoutes;
